
import { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  CircularProgress,
  Typography
} from "@mui/material";
import { useFormik } from "formik";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import MultiSelectDropdown from "../../../../components/MultiSelectionDropdown";
import CustomButton from "../../../../components/CustomButton";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../../../components/BaseUrl";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import { toast } from "react-hot-toast"; // 👈 add this import at the top
import document1 from "../../../../assets/document1.svg"; // pdf icon
import Webcam from "react-webcam";
import { useRef } from "react";
import { convertLocalDateTimeToUTC } from "../../../../components/dateTimeUtils.js";

const AddDocDrawer = ({ open, onClose,onSuccess  }) => {
  const { t } = useTranslation();
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const [loading, setLoading] = useState(false);      // first full load
const [uploading, setUploading] = useState(false);  // file upload in progress
const { company } = useSelector((state) => state.auth);
const companyId = company?.id;
console.log(companyId)
const [openCamera, setOpenCamera] = useState(false);
const webcamRef = useRef(null);

  const [workers, setWorkers] = useState([]);
  
  const formik = useFormik({
    initialValues: {
      docName: "",
      subject: "",
      viewAccess: "all", // all | specific
      selectedWorkers: [],
      description: "",
    file: null,
fileUrl: null,
    expires_at: "",
    },
    validate: (values) => {
      const errors = {};
      
      // Document Name
      if (!values.docName || (typeof values.docName === "string" && values.docName.trim() === "")) {
        errors.docName = t("addDocument.validation.docNameRequired") || "Document name is required";
      }
      // Subject
      if (!values.subject || (typeof values.subject === "string" && values.subject.trim() === "")) {
        errors.subject = t("addDocument.validation.subjectRequired") || "Subject is required";
      }
      // Employees — must pick "All" or at least one specific worker, otherwise
      // access_mode ends up "specific" with zero recipients (a document nobody can see).
      if (!values.selectedWorkers || values.selectedWorkers.length === 0) {
        errors.selectedWorkers = t("addDocument.validation.workersRequired") || "Select at least one employee or \"All\"";
      }
 if (!values.file) {
  errors.file = t("addDocument.validation.documentRequired");
}
      
      return errors;
    },
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      setLoading(true);
      try {
       if (!values.fileUrl) {
  toast.error(t("addDocument.validation.pdfRequired"));
  setLoading(false);
  return;
}

        // Validate subject before sending
        if (!values.subject || (typeof values.subject === "string" && values.subject.trim() === "")) {
          toast.error(t("addDocument.validation.subjectRequired") || "Subject is required");
  setLoading(false);
  return;
}

        // Validate employees before sending — prevents an ambiguous
        // access_mode: "specific" with zero recipients.
        if (!values.selectedWorkers || values.selectedWorkers.length === 0) {
          toast.error(t("addDocument.validation.workersRequired") || "Select at least one employee or \"All\"");
  setLoading(false);
  return;
}

        // prepare body
        const body = {
          name: values.docName?.trim() || "",
          subject: values.subject?.trim() || "",
          description: values.description?.trim() || "",
        file_id: values.fileUrl,
file_type: values.file?.type === "application/pdf" ? "pdf" : "image",
          access_mode: values.selectedWorkers.includes("All") ? "all" : "specific",
          recipients: values.selectedWorkers.includes("All")
            ? [] // no specific recipients if access is all
            : values.selectedWorkers.map((w) => {
                // 🟢 extract worker id from "Firstname Lastname (id:8)" if needed
                const found = (workers || []).find((worker) => worker.value === w);
                // You need worker IDs not names, so ideally map should store {id, name}
                return found?.value || w; 
              }),
        };
        if (values.expires_at) {
          body.expires_at =
            convertLocalDateTimeToUTC(values.expires_at) || values.expires_at;
        }

        console.log("📤 Final payload:", body);

        const res = await fetch(`${BASE_URL}/documents`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
          body: JSON.stringify(body),
        });

        const data = await res.json();
        if (!res.ok || data.error) {
          const errorMessage = data.message || data.error || "Failed to save document";
          console.error("❌ API Error Response:", data);
          throw new Error(errorMessage);
        }

        toast.success(data.message || "Document uploaded successfully");
        console.log("✅ Document saved:", data);
        if (onSuccess) onSuccess();

        formik.resetForm();
        onClose();
      } catch (err) {
        console.error("❌ Error saving document:", err);
        toast.error(err.message || "Failed to save document");
      } finally {
        setLoading(false);
      }
    },
  });
  
useEffect(() => {
  if (!open) {
    formik.resetForm();
  }
}, [open]);

  // 🔹 Fetch workers from API
useEffect(() => {
  const fetchWorkers = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}/public/workers?no_pagination=true&company_id=${companyId}&status=active`
      );
      if (!res.ok) throw new Error("Failed to fetch workers");
      const data = await res.json();

      // Map into string names instead of objects
      const workerNames = (data?.data?.records || []).map(
        (w) => `${w.first_name} ${w.last_name} (${w.email})`
        

      );

      // Prepend "All" option
      // setWorkers(["All", ...workerNames]);
      setWorkers([
  { label: "All", value: "All" },
  ...(data?.data?.records || []).map((w) => ({
    label: `${w.first_name} ${w.last_name} (${w.email})`,
    value: w.id,
  }))
]);
    } catch (err) {
      console.error("❌ Error fetching workers:", err);
    }
  };
  if (decryptedToken) fetchWorkers();
}, [decryptedToken]);
const handleDropdownChange = ({ target: { name, value } }) => {
  let newValue = value;

  // If "All" is selected → keep only "All"
  if (value.includes("All")) {
    newValue = ["All"];
  } else {
    // Ensure "All" is removed if other workers are selected
    newValue = value.filter((v) => v !== "All");
  }

  // Return the promise so callers can await it before marking the field
  // touched — otherwise touched-triggered validation can run against the
  // stale (pre-update) value, same race condition as the file upload fix.
  return formik.setFieldValue(name, newValue);
};
// Backend's /upload/pdf enforces a hard 10MB limit (upload.routes.js) —
// mirror it client-side so oversized files are rejected instantly with a
// clear message instead of silently uploading and failing.
const MAX_PDF_SIZE_BYTES = 10 * 1024 * 1024;

const handleFileUpload = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const isPdf = file.type === "application/pdf";

  if (isPdf && file.size > MAX_PDF_SIZE_BYTES) {
    const message =
      t("addDocument.validation.pdfSizeExceeded") ||
      "PDF file size must be less than 10MB";
    toast.error(message);
    formik.setFieldError("file", message);
    formik.setFieldTouched("file", true, false);
    return;
  }

  const formData = new FormData();
  formData.append(isPdf ? "pdf" : "image", file);

  const uploadUrl = isPdf
    ? `${BASE_URL}/upload/pdf`
    : `${BASE_URL}/upload/image`;

  try {
    setUploading(true);
    const res = await fetch(uploadUrl, {
      method: "POST",
      body: formData,
    });

    const data = await res.json().catch(() => null);

    if (!res.ok) {
      throw new Error(data?.message || "Upload failed");
    }

    const uploadedUrl = data?.data?.url;

    // ✅ SET FILE (DO NOT CLEAR IT)
    // Set the value, explicitly clear the "required" error, and mark the
    // field touched WITHOUT re-triggering validation (3rd arg = false) —
    // relying on Formik's own re-validation timing here previously let a
    // stale "file required" error render for a moment right after a
    // successful upload.
    await formik.setValues((prev) => ({ ...prev, file, fileUrl: uploadedUrl }));
    formik.setFieldError("file", undefined);
    formik.setFieldTouched("file", true, false);

    toast.success(
      data?.message || `${isPdf ? "PDF" : "Image"} uploaded successfully`
    );
  } catch (err) {
    console.error("❌ Upload error:", err);
    toast.error(err.message || "Failed to upload file");
    formik.setFieldError("file", err.message || "Failed to upload file");
    await formik.setValues((prev) => ({ ...prev, file: null, fileUrl: null }));
    formik.setFieldTouched("file", true, false);
  } finally {
    setUploading(false);
  }
};




const capturePhoto = async () => {
  const imageSrc = webcamRef.current.getScreenshot();
  if (!imageSrc) return;

  const blob = await fetch(imageSrc).then((res) => res.blob());
  const file = new File([blob], `camera_${Date.now()}.jpg`, {
    type: "image/jpeg",
  });

  const fakeEvent = {
    target: { files: [file] },
  };

  setOpenCamera(false);
  handleFileUpload(fakeEvent);
};

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 540,
          maxWidth: "100%",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1.5,
          borderBottom: "1px solid #E0E0E0",
          backgroundColor: "#f5f6f7",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 600,
              color: "#172B4D",
            }}
          >
            {t("addDocument.addHeading") || "Add Document"}
          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ p: 3, flexGrow: 1, overflowY: "auto" }}>
        <CustomText
          sx={{
            ...textStyles.h1,
            fontSize: 18,
            fontWeight: 600,
            mb: 2,
            color: "#172B4D",
            textAlign: "left",
          }}
        >
          {t("addDocument.detailsHeading") || "Document Details"}
        </CustomText>

        {/* Doc Name */}
        <Box mb={2}>
          <label className="field_label">
            {t("addDocument.form.docName")} <span className="red_asterisk">*</span>
          </label>
          <input
            type="text"
            name="docName"
            value={formik.values.docName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="project_input"
            style={{
              width: "100%",
              marginTop: 6,
              height: "42px",
              border: formik.touched.docName && formik.errors.docName
                ? "2px solid #d32f2f"
                : "2px solid #091E4224"
            }}
          />
          {formik.touched.docName && formik.errors.docName && (
            <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
              {formik.errors.docName}
            </span>
          )}
        </Box>

        {/* Subject */}
        <Box mb={2}>
          <label className="field_label">
            {t("documentsTable.th.subject") || "Subject"} <span className="red_asterisk">*</span>
          </label>
          <input
            type="text"
            name="subject"
            value={formik.values.subject}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="project_input"
            style={{
              width: "100%",
              marginTop: 6,
              height: "42px",
              border: formik.touched.subject && formik.errors.subject
                ? "2px solid #d32f2f"
                : "2px solid #091E4224"
            }}
          />
          {formik.touched.subject && formik.errors.subject && (
            <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
              {formik.errors.subject}
            </span>
          )}
        </Box>

        {/* View Access as Radio */}
  

          <Box mb={2}>
           <MultiSelectDropdown
           enableSearch={true}
    label={<>{t("addDocument.form.workers")} <span className="red_asterisk" style={{ color: "red" }}>*</span></>}
    name="selectedWorkers"
    values={formik.values.selectedWorkers}
    onChange={async (e) => {
      await handleDropdownChange(e);
      formik.setFieldTouched("selectedWorkers", true);
    }}
    options={workers} // ["All", "Worker1", "Worker2", ...]
          />
          {formik.touched.selectedWorkers && formik.errors.selectedWorkers && (
            <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
              {formik.errors.selectedWorkers}
            </span>
          )}
        </Box>

        {/* Description */}
        <Box mb={2}>
          <label className="field_label">{t("addDocument.form.description")}</label>
          <textarea
            name="description"
            rows={4}
            className="project_input"
            style={{ width: "100%", marginTop: 6 }}
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Box>

        {/* Expires At (optional) */}
        <Box mb={2}>
          <label className="field_label">
            {t("documentsTable.th.expiresAt") || "Expires At"} ({t("common.optional") || "Optional"})
          </label>
          <input
            type="date"
            name="expires_at"
            value={formik.values.expires_at}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="project_input"
            style={{ width: "100%", marginTop: 6, height: 40 }}
          />
        </Box>

        {/* PDF Upload */}
   <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 0.5,
  }}
>
  <CustomText
    sx={{
      fontSize: "14px",
      fontWeight: 500,
      color: "#6B778C",
    }}
  >
    {t("addDocument.form.pdf")} <span className="red_asterisk">*</span>
  </CustomText>
{/* <CustomText
  sx={{
    fontSize: 15,
    fontWeight: 500,
    color: "#1976d2",
    cursor: "pointer",
              fontFamily: "Poppins, sans-serif",

    mb: 1,
  }}
  onClick={() => setOpenCamera(true)}
>
  {t("taskAddModal.takePhoto")}
</CustomText> */}
</Box>

<Box
  sx={{
    border: formik.touched.file && formik.errors.file
      ? "2px dashed #d32f2f"
      : "2px dashed #D0D5DD",
    borderRadius: 2,
    p: 3,
    textAlign: "center",
    backgroundColor: "#F9FAFB",
    cursor: "pointer",
    mb:0.5,
    height: 160,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  }}
>
 {uploading ? (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5 }}>
      <CircularProgress size={28} sx={{ color: "#006EC2" }} />
      <CustomText sx={{ fontSize: 14, fontWeight: 500, color: "#6B778C" }}>
        {t("addDocument.form.uploading") || "Uploading..."}
      </CustomText>
    </Box>
  ) : !formik.values.file ? (

    <label htmlFor="pdf-upload" style={{ cursor: "pointer" }}>
      <input
        type="file"
        id="pdf-upload"
        name="pdf"
                // accept="image/*,application/pdf"

        accept="application/pdf"
  onChange={handleFileUpload}
        hidden
      />
      <CustomText sx={{ fontSize: 14, fontWeight: 500 }}>
        {t("addDocument.form.dragDrop")}{" "}
        <span style={{ textDecoration: "underline", color: "#006EC2" }}>
          {t("addDocument.form.browse")}
        </span>
      </CustomText>
    </label>
  ) : (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
      }}
    >
   
        <Box sx={{ textAlign: "center" }}>
    {formik.values.file.type === "application/pdf" ? (
      <img src={document1} alt="PDF" style={{ width: 45 }} />
    ) : (
      <img
        src={URL.createObjectURL(formik.values.file)}
        alt="Preview"
        style={{ maxWidth: 120, maxHeight: 80, objectFit: "contain" }}
      />
    )}

    <CustomText sx={{ fontSize: 14 }}>
      {formik.values.file.name}
    </CustomText>

    <CustomText sx={{ fontSize: 12, color: "#6B778C" }}>
      {(formik.values.file.size / (1024 * 1024)).toFixed(2)} MB
    </CustomText>
  </Box>
    </Box>
  )}

{formik.values.file && (
  <IconButton
    size="small"
    onClick={async () => {
      await formik.setValues((prev) => ({ ...prev, file: null, fileUrl: null }));
      formik.setFieldTouched("file", true);
    }}
    sx={{
      position: "absolute",
      top: 8,
      right: 8,
      backgroundColor: "#fff",
      border: "1px solid #E0E0E0",
    }}
  >
    <img src={profilecross} alt="remove" style={{ width: 20, height: 20 }} />
  </IconButton>
)}

</Box>
{formik.touched.file && formik.errors.file && (
  <span style={{ color: "#d32f2f", fontSize: "12px" }}>
    {formik.errors.file}
  </span>
)}
<Typography  sx={{
      fontSize: 13,
          fontWeight: 500,
          fontFamily: "Poppins, sans-serif",
          textAlign: "left",
  }}>
  {t("addDocument.validation.pdfRequired")}
</Typography>





        {/* Save Button */}
        <CustomButton
    label={
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            {loading && <CircularProgress size={18} sx={{ color: "#fff", mr: 1 }} />} {/* ✅ loader */}
            {t("common.save") || "Save"}
          </Box>
        }          sx={{ mt: 2 }}
          onClick={formik.handleSubmit}
          size="small"
        />
      </Box>
      {openCamera && (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.6)",
      zIndex: 2000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Box
      sx={{
        background: "#fff",
        borderRadius: 2,
        p: 2,
        width: 360,
      }}
    >
      <Webcam
        ref={webcamRef}
        audio={false}
        screenshotFormat="image/jpeg"
        videoConstraints={{ facingMode: "environment" }}
        style={{ width: "100%", borderRadius: 8 }}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap:2,
          mt: 2,
        }}
      >
        <CustomButton
          label={t("taskAddModal.camera.cancel")}
          variant="outlined"
          onClick={() => setOpenCamera(false)}
                             sx={{   fontFamily: 'Poppins, sans-serif',textTransform:"capitalize"}}

        />

        <CustomButton
          label={t("taskAddModal.camera.capture")}
          onClick={capturePhoto}
                             sx={{   fontFamily: 'Poppins, sans-serif',textTransform:"capitalize"}}

        />
      </Box>
    </Box>
  </Box>
)}

    </Drawer>
  );
};

export default AddDocDrawer;





